import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu';
import { styled } from '../../system';
import { Checkbox } from '../Checkbox';
import { forwardRef } from 'react';
import { Radio, RadioGroup } from '../Radio';
import { popoverContentStyle } from '../Popover';
import { wrapWithDefaultProps } from '../../lib/wrap-with-default-props';
export const dropdownMenuItemCSS = {
    textSm: true,
    lineHeight: 1,
    color: '$text',
    d: 'flex',
    minH: 44,
    alignItems: 'center',
    px: '$4',
    position: 'relative',
    userSelect: 'none',
    cursor: 'pointer',
    textMd: true,
    '&[data-disabled]': {
        opacity: 0.8,
        pointerEvents: 'none'
    },
    '&[data-highlighted], &[data-state="checked"]': {
        bgColor: '$hoverBg',
        color: '$hoverText',
        outline: 'none'
    }
};
export const dropdownMenuIndicatorCSS = {
// position: 'absolute',
// left: 0,
// top: 0,
// bottom: 0,
// width: 2,
// bgColor: '$primary'
};
const StyledContent = styled(DropdownMenuPrimitive.Content, {
    ...popoverContentStyle
});
const StyledSubContent = styled(DropdownMenuPrimitive.SubContent, {
    ...popoverContentStyle
});
const StyledItem = styled(DropdownMenuPrimitive.Item, {
    ...dropdownMenuItemCSS
});
const StyledCheckboxItem = styled(DropdownMenuPrimitive.CheckboxItem, {
    ...dropdownMenuItemCSS
});
const StyledRadioItem = styled(DropdownMenuPrimitive.RadioItem, {
    ...dropdownMenuItemCSS
});
const StyledSubTrigger = styled(DropdownMenuPrimitive.SubTrigger, {
    '&[data-state="open"]': {
        bgColor: '$hoverBg',
        color: '$hoverText'
    },
    ...dropdownMenuItemCSS
});
const StyledLabel = styled(DropdownMenuPrimitive.Label, {
    textXs: true,
    px: '$4',
    color: '$textMuted',
    lineHeight: '$lg'
});
const StyledSeparator = styled(DropdownMenuPrimitive.Separator, {
    h: 1,
    bgColor: '$separatorColor'
});
const StyledItemIndicator = styled(DropdownMenuPrimitive.ItemIndicator, {
    ...dropdownMenuIndicatorCSS
});
const StyledMenuSub = styled(DropdownMenuPrimitive.Sub, {});
const StyledRadioGroup = styled(DropdownMenuPrimitive.RadioGroup, {});
const StyledTrigger = styled(DropdownMenuPrimitive.Trigger, {});
const StyledRoot = styled(DropdownMenuPrimitive.Root, {});
export const DropdownMenuContent = forwardRef(({ children, disablePortal, sideOffset = 8, ...props }, ref) => disablePortal ? (_jsx(StyledContent, { ref: ref, ...props, sideOffset: sideOffset, children: children })) : (_jsx(DropdownMenuPrimitive.Portal, { children: _jsx(StyledContent, { ref: ref, ...props, children: children }) })));
export const DropdownMenuSubContent = forwardRef(({ sideOffset = 4, alignOffset = 0, ...props }, ref) => (_jsx(DropdownMenuPrimitive.Portal, { children: _jsx(StyledSubContent, { ref: ref, ...props, alignOffset: alignOffset, sideOffset: sideOffset }) })));
export const DropdownMenuRadioGroup = forwardRef((props, ref) => (_jsx(RadioGroup, { defaultChecked: props.defaultChecked, value: props.value, asChild: true, children: _jsx(StyledRadioGroup, { ref: ref, ...props }) })));
export const DropdownMenuRadioItem = forwardRef((props, ref) => (_jsxs(StyledRadioItem, { ref: ref, ...props, children: [_jsx(Radio, { css: { mr: '$2' }, defaultChecked: props.defaultChecked, value: props.value }), props.children] })));
export const DropdownMenuCheckboxItem = forwardRef((props, ref) => (_jsxs(StyledCheckboxItem, { ref: ref, ...props, children: [_jsx(Checkbox, { css: { mr: '$2' }, checked: props.checked, defaultChecked: props.defaultChecked }), props.children] })));
export const DropdownMenu = wrapWithDefaultProps(StyledRoot, { modal: false });
export const DropdownMenuTrigger = wrapWithDefaultProps(StyledTrigger, {
    asChild: true
});
export const DropdownMenuItem = StyledItem;
export const DropdownMenuItemIndicator = StyledItemIndicator;
export const DropdownMenuLabel = StyledLabel;
export const DropdownMenuSeparator = StyledSeparator;
export const DropdownMenuSub = StyledMenuSub;
export const DropdownMenuSubTrigger = StyledSubTrigger;
DropdownMenu.displayName = 'DropdownMenu';
DropdownMenuTrigger.displayName = 'DropdownMenuTrigger';
DropdownMenuContent.displayName = 'DropdownMenuContent';
DropdownMenuItem.displayName = 'DropdownMenuItem';
DropdownMenuCheckboxItem.displayName = 'DropdownMenuCheckboxItem';
DropdownMenuRadioGroup.displayName = 'DropdownMenuRadioGroup';
DropdownMenuRadioItem.displayName = 'DropdownMenuRadioItem';
DropdownMenuItemIndicator.displayName = 'DropdownMenuItemIndicator';
DropdownMenuLabel.displayName = 'DropdownMenuLabel';
DropdownMenuSeparator.displayName = 'DropdownMenuSeparator';
DropdownMenuSub.displayName = 'DropdownMenuSub';
DropdownMenuSubTrigger.displayName = 'DropdownMenuSubTrigger';
DropdownMenuSubContent.displayName = 'DropdownMenuSubContent';
